const ALLOWED_PROTOCOLS = ["http:", "https:"];

export function getSafeExternalUrl(value) {
  if (!value) return null;

  try {
    const url = new URL(value);

    if (!ALLOWED_PROTOCOLS.includes(url.protocol)) {
      return null;
    }

    return url.toString();
  } catch {
    return null;
  }
}
